import React from 'react';

import { USDT, formatUSDNoDecimals } from '../../../../helpers/helperFunctions';
import { H3, H4, P2, P3 } from '../../../../styles/FontStyles';
import { Flexed } from '../../../../styles/GlobalComponents';
import { colors } from '../../../../styles/GlobalStyles';
import { HubImage, HubStyled } from './WithdrawHub.styled';
import moment from 'moment';

export const WithdrawHub = ({
  id,
  nftId,
  image,
  title,
  price,
  dateOfPurchase
}: any) => {
  return (
    <HubStyled
      condensed={false}
      selected={false}
      includesSubscription={false}
      style={{ marginBottom: 20 }}>
      <div>
        <HubImage condensed={false} image={image} />

        <Flexed column between>
          <H3 color={colors.primary900} mb='20'>
            {title}
          </H3>

          <Flexed column between>
            {price && (
              <Flexed>
                <P2 mb='5' mr='5'>
                  PRICE:
                </P2>
                <P2 bold>
                  {formatUSDNoDecimals(price)} {USDT}{' '}
                </P2>
              </Flexed>
            )}

            <Flexed>
              <P2 mb='5' mr='5'>
                DATE OF PURCHASE:
              </P2>
              <P2 bold>{moment(dateOfPurchase).format('D.MM.YYYY')}</P2>
            </Flexed>
            {id && (
              <Flexed>
                <P2 mb='5' mr='5'>
                  ORDER ID:
                </P2>
                <P2 bold>{id}</P2>
              </Flexed>
            )}

            <Flexed>
              <P2 mb='5' mr='5'>
                NFT ID:
              </P2>
              <P2 bold>{nftId}</P2>
            </Flexed>
          </Flexed>
        </Flexed>
      </div>
    </HubStyled>
  );
};
